import {jsx} from 'panel';
import {ParamComponent} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import css from './index.inline.styl';

export enum TileImageId {
  ADD_REPORT = `add-report`,
  START_FROM_TEMPLATE = `start-from-template`,
  COMPANY_KPIS = `company-kpis`,
  FEATURE_LAUNCH = `feature-launch`,
  MARKETING_KPIS = `marketing-kpis`,
  LIFECYCLE_COHORT_ANALYSIS = `lca`,
  ECOMMERCE = `ecommerce`,
}

export enum TileTheme {
  // if theme needs to be altered, double check that it doesn't break in other usages
  PADDED_IMAGE = `padded-image`, // ex: in empty-hero
  FULL_IMAGE = `full-image`, // ex: in boards-template-modal
  NO_IMAGE = `no-image`, // ex: in rhs-panel
}

export type TileType = {
  imageId?: TileImageId;
  title?: string;
  description?: string;
  theme?: TileTheme;
  selected?: boolean;
  fillWidth?: boolean;
};

type TileJsxProps = {
  params: TileType;
};

export class Tile extends ParamComponent<TileType, EmptyObj> {
  get config() {
    return {
      useShadowDom: true,
      css,
      template: () => {
        const themeClass = this.params.theme || TileTheme.PADDED_IMAGE; // default to padded image theme
        return (
          <div
            class={{selected: this.params.selected, 'fill-width': this.params.fillWidth}}
            sel={`.mp-tile-wrapper.${themeClass}`}
          >
            <div sel={`.mp-tile-top.${themeClass}`}>
              <div sel={`#${this.params.imageId}.mp-tile-image.${themeClass}`} />
            </div>
            <div sel={`.mp-tile-bottom.${themeClass}`}>
              <div sel={`.mp-tile-title.${themeClass}`}>{this.params.title}</div>
              <div sel={`.mp-tile-description.${themeClass}`}>
                {this.params.description}
                <div>
                  <slot />
                </div>
              </div>
            </div>
          </div>
        );
      },
      params: {
        imageId: {
          type: String,
          required: false,
        },
        title: {
          type: String,
          required: false,
        },
        description: {
          type: String,
          required: false,
        },
        theme: {
          type: String,
          required: false,
        },
        selected: {
          type: Boolean,
          required: false,
        },
        fillWidth: {
          type: Boolean,
          required: false,
        },
      },
    };
  }
}

export const TileEl = defineAndMakeJsxFactory<TileJsxProps>(`mp-tile`, Tile);
export const TileReact = panel2react<TileJsxProps>(`mp-tile`, Tile);
